<smrts-page primaryTitle="Página inicial">

  <div class="page-content">

    <div class="logo-container">
      <img class="logo" src="assets/img/gma_tipografia.png" alt="GMA" />
    </div>

    @for (modulo of modulos; track modulo) {
      <section *hasPermission="permissoesModulo(modulo)" class="modulo">
        <h3 class="modulo-titulo low-emphasis">{{ modulo.titulo }}</h3>
        <div class="atalhos">
          @for (atalho of modulo.atalhos; track atalho) {
            <a *hasPermission="atalho.permissao" class="atalho" [ngClass]="atalho.classe" [routerLink]="atalho.url">
              <mat-card class="atalho-card">
                <div class="atalho-icone">
                  <mat-icon>{{ atalho.icone }}</mat-icon>
                </div>
                <div class="atalho-texto">
                  <span class="atalho-titulo high-emphasis">{{ atalho.titulo }}</span>
                  <span class="atalho-descricao medium-emphasis">{{ atalho.descricao }}</span>
                </div>
                <mat-icon class="atalho-seta low-emphasis">chevron_right</mat-icon>
              </mat-card>
            </a>
          }
        </div>
      </section>
    }

  </div>

</smrts-page>
